import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { getHomePerformancesAction, getHomeNumbersAction, getHomeArtistsAction } from './actions';
import { getProductions, getHomeNumbers, searchProfiles } from '../../utils/API';
import { dateSendFormat } from '../../utils/common';
import { ARTIST_TYPE_ID } from '../../constants/consts';

export function* fetchArtists() {
  try {
    const response = yield call(
      searchProfiles,
      ARTIST_TYPE_ID,
      '',
      { limit: 14, page: 1 },
      { sort: 'random', tier: 'A' },
    );
    yield put(getHomeArtistsAction.success(get(response, 'data')));
  } catch (err) {
    yield put(getHomeArtistsAction.failure(err.message));
  } finally {
    yield put(getHomeArtistsAction.fulfill());
  }
}

export function* fetchPerformances({ payload }) {
  try {
    const response = yield call(
      getProductions,
      {
        ...payload,
        date_from: dateSendFormat(),
        date_to: dateSendFormat(),
        added_by: 'admin, company',
        approved_by: 'admin, company',
      },
      { limit: 5 },
    );
    yield put(getHomePerformancesAction.success(get(response, 'data')));
  } catch (err) {
    yield put(getHomePerformancesAction.failure(err.message));
  } finally {
    yield put(getHomePerformancesAction.fulfill());
  }
}

export function* fetchHomeNumbers() {
  try {
    const response = yield call(getHomeNumbers, { id: 'all' });

    yield put(getHomeNumbersAction.success(get(response, 'data')));
  } catch (err) {
    yield put(getHomeNumbersAction.failure(err.message));
  } finally {
    yield put(getHomeNumbersAction.fulfill());
  }
}

export default function* homeSaga() {
  yield takeLatest(getHomeArtistsAction.TRIGGER, fetchArtists);
  yield takeLatest(getHomePerformancesAction.TRIGGER, fetchPerformances);
  yield takeLatest(getHomeNumbersAction.TRIGGER, fetchHomeNumbers);
}
